import { z } from '@harvestiq/zod';
import { faqSchema } from './faq';

export const getFaqsRequestSchema = z.object({
  isActive: z.boolean().optional(),
});

export type GetFaqsRequest = z.infer<typeof getFaqsRequestSchema>;

export const getFaqsResponseSchema = z.object({
  success: z.boolean(),
  faqs: z.array(faqSchema),
});

export type GetFaqsResponse = z.infer<typeof getFaqsResponseSchema>;
